import { TypeFactory } from '../_pages/QuestionLibrary/Create/Types/';
import { questionLibraryConstants as constants } from '../_constants/question-library.constants'

export const initialState = {
  collection: { data: [] },
  current: null,
  currentId: null,
  isSaving: false,
  isLoading: false,
  promptWarning: true
}

export function questionLibrary(state = initialState, action) {

  if (action.type === constants.QUESTION_SET_SUPPORT_LINK) {
    const supportLink = state.current.extension.find((extension) => {
      return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink'
    });

    if (!supportLink) {
      return {
        ...state,
        current: {
          ...state.current,
          extension: [
            ...state.current.extension,
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink',
              valueUri: action.url
            }
          ]
        }
      }
    } else {
      return {
        ...state,
        current: {
          ...state.current,
          extension: state.current.extension.map((extension) => {
            if (extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink') {
              return {
                url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink',
                valueUri: action.url
              }
            }

            return extension;
          })
        }
      }
    }
  }

  if (action.type === constants.QUESTION_SET_SUPPORT_IMAGE) {
    const supportImage = state.current.extension.find((extension) => {
      return extension.url === 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage'
    });

    if (!supportImage) {
      return {
        ...state,
        current: {
          ...state.current,
          extension: [
            ...state.current.extension,
            {
              url: 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage',
              valueUri: action.url
            }
          ]
        }
      }
    } else {
      return {
        ...state,
        current: {
          ...state.current,
          extension: state.current.extension.map((extension) => {
            if (extension.url === 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage') {
              return {
                url: 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage',
                valueUri: action.url
              }
            }

            return extension;
          })
        }
      }
    }
  }

  if (action.type === constants.CANCEL_EDIT) {
    return {
      ...state,
      current: null,
      currentId: null,
      promptWarning: false
    }
  }

  if (action.type === constants.QUESTION_SET_PROMPT_WARNING) {
    return {
      ...state,
      promptWarning: action.flag
    }
  }

  if (action.type === constants.GET_QUESTION_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  if (action.type === constants.GET_QUESTION_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      current: action.question.resource,
      currentId: action.question.id
    }
  }

  if (action.type === constants.GETALL_QUESTIONS_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      collection: action.collection
    }
  }

  if (action.type === constants.GETALL_QUESTIONS_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  if (action.type === constants.SET_CHOICE_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        extension: state.current.extension.map((extension) => {
          if (extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl') {
            return {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
              valueCodeableConcept: {
                coding: [{
                  system: 'http://hl7.org/fhir/questionnaire-item-control',
                  code: action.choiceType
                }]
              }
            }
          }

          return extension;
        })
      }
    }
  }

  if (action.type === constants.UPDATE_OPTION) {
    return {
      ...state,
      current: {
        ...state.current,
        answerOption: state.current.answerOption.map((option, i) => {
          if (i === action.position) {
            return {
              valueCoding: {
                code: action.option
              }
            }
          }

          return option;
        })
      }
    }
  }

  if (action.type === constants.REMOVE_OPTION) {
    return {
      ...state,
      current: {
        ...state.current,
        answerOption: state.current.answerOption.filter((option) => {
          return option.valueCoding.code !== action.option.valueCoding.code;
        })
      }
    }
  }

  if (action.type === constants.ADD_OPTION) {
    return {
      ...state,
      current: {
        ...state.current,
        answerOption: [
          ...state.current.answerOption,
          {
            valueCoding: {
              code: action.option
            }
          }
        ]
      }
    }
  }

  if (action.type === constants.SAVE_QUESTION_SUCCESS) {
    return {
      ...state,
      isSaving: false,
      current: null,
      currentId: null,
      saveSuccess: true
    }
  }

  if (action.type === constants.SAVE_QUESTION_REQUEST) {
    return {
      ...state,
      isSaving: true,
      promptWarning: false
    }
  }

  if (action.type === constants.SAVE_QUESTION_FAILURE) {
    return {
      ...state,
      isSaving: false,
      promptWarning: true
    }
  }

  if (action.type === constants.SET_TEXT) {
    return {
      ...state,
      current: {
        ...state.current,
        text: action.text
      }
    }
  }

  if (action.type === constants.CANCEL) {
    return {
      ...state,
      current: null,
      currentId: null,
    }
  }

  if (action.type === constants.SET_FIELD_TYPE) {
    return {
      ...state,
      current: Object.assign({}, TypeFactory(action.typeId))
    }
  }

  if (action.type === constants.QUESTION_INIT_STATE) {
    return initialState;
  }

  return state;
}